(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ne-360"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ne-360')) {
    customElements.define('ne-360', class extends HTMLElement {
      connectedCallback() {
        this.img   = this.querySelector('.ne-360__img');
        this.loader = this.querySelector('[data-ne-360-loader]');
        this.bar   = this.querySelector('[data-ne-360-bar]');
        this.base  = this.dataset.base;
        this.count = parseInt(this.dataset.count, 10) || 36;
        this.ext   = this.dataset.ext || '.webp';

        this.frames = [];
        this.current = 0;
        this.ready = false;
        this.interacted = false;

        this._bindDrag();

        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            if (entries.some(e => e.isIntersecting)) { this._io.disconnect(); this._preload(); }
          }, { rootMargin: '300px' });
          this._io.observe(this);
        } else {
          this._preload();
        }
      }

      _url(i) { return this.base + String(i).padStart(3, '0') + this.ext; }

      _preload() {
        if (this._loading) return;
        this._loading = true;
        this.loader.hidden = false;
        var loaded = 0, self = this;
        for (var i = 1; i <= this.count; i++) {
          (function (i) {
            var im = new Image();
            im.onload = im.onerror = function () {
              loaded++;
              self.bar.style.width = Math.round(loaded / self.count * 100) + '%';
              if (loaded === self.count) self._activate();
            };
            im.src = self._url(i);
            self.frames[i - 1] = im;
          })(i);
        }
        this._fallback = setTimeout(function () { self._activate(); }, 8000);
      }

      _activate() {
        if (this.ready) return;
        this.ready = true;
        clearTimeout(this._fallback);
        this.loader.hidden = true;
      }

      _show(idx) {
        idx = ((idx % this.count) + this.count) % this.count;
        this.current = idx;
        var f = this.frames[idx];
        if (f && f.src) this.img.src = f.src; else this.img.src = this._url(idx + 1);
      }

      _bindDrag() {
        var self = this, dragging = false, startX = 0, startFrame = 0;
        var STEP = 8; // Pixel pro Frame

        function down(x) {
          if (!self._loading) self._preload();   // Laden spaetestens jetzt anstossen
          dragging = true; startX = x; startFrame = self.current;
          self.classList.add('is-grabbing');
          if (!self.interacted) { self.interacted = true; self.classList.add('is-active'); }
        }
        function move(x) {
          if (!dragging) return;
          var delta = Math.round((x - startX) / STEP);
          self._show(startFrame - delta);          // _show laedt fehlende Frames on-demand
        }
        function up() { dragging = false; self.classList.remove('is-grabbing'); }

        // Pointer Events + Capture: der Zeiger wird eingefangen -> Dawns Mobil-Slider
        // (scroll-snap) bekommt die Horizontal-Geste nicht und blaettert NICHT weiter.
        this.addEventListener('pointerdown', function (e) {
          try { self.setPointerCapture(e.pointerId); } catch (_) {}
          down(e.clientX);
        });
        this.addEventListener('pointermove', function (e) {
          if (dragging) { e.stopPropagation(); move(e.clientX); }
        });
        this.addEventListener('pointerup', function (e) {
          try { self.releasePointerCapture(e.pointerId); } catch (_) {}
          up();
        });
        this.addEventListener('pointercancel', up);
        this.addEventListener('lostpointercapture', up);

        // Klick auf der 360°-Kachel NIE an Dawns modal-opener (Zoom-Lightbox)
        // durchreichen. Capture-Phase + stopImmediatePropagation blockt den
        // .product__media-toggle-Button zuverlaessig.
        this.addEventListener('click', function (e) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }, true);
      }

      disconnectedCallback() { if (this._io) this._io.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
